<template>
  <div class="modal-clone-lesson p-5">
    <strong>
      Copiar aula existente
    </strong>
    <action-dispatcher
      class="my-5"
      action="product/get"
      :parameters="{ limit: 100 }"
    >
      <form-group
        select
        id="product-select"
        :options="products"
        label="Selecione o produto"
        placeholder="Selecione o produto..."
        v-model="product_id"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="product_id"
      :key="product_id"
      action="membersModules/get"
      :parameters="{ product_id, commit: false }"
      @success="setModules"
    >
      <form-group
        select
        id="module-select"
        label="Selecione o módulo"
        placeholder="Selecione o módulo..."
        v-model="module_id"
        :options="modules"
      />
    </action-dispatcher>
    <action-dispatcher
      v-if="module_id"
      :key="module_id"
      action="membersLessons/get"
      :parameters="{ product_id, module_id }"
      @success="setLessons"
    >
      <form-group
        select
        id="lesson-select"
        label="Selecione a aula"
        placeholder="Selecione a aula..."
        v-model="lesson_id"
        :options="lessons"
      />
    </action-dispatcher>

    <div class="mt-6 row">
      <div class="col-lg-6 order-lg-1">
        <button
          class="btn btn-block"
          :disabled="!isValid"
          :class="isValid ? 'btn-primary' : 'btn-secondary'"
          @click="submit"
        >
          <loading :show="loading">Confirmar</loading>
        </button>
      </div>
      <div class="col-lg-6">
        <button
          class="btn btn-outline-secondary btn-block"
          @click="$emit('close')"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    module: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      product_id: "",
      module_id: "",
      lesson_id: "",
      modules: {},
      lessons: {}
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.product_id && this.module_id && this.lesson_id;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store
        .dispatch("membersLessons/clone", {
          lesson_id: this.lesson_id,
          target_product: this.$route.params.id,
          target_module: this.module
        })
        .then(() => {
          this.$router.go(0);
        })
        .finally(() => {
          this.loading = false;
          this.$message.success("Aula copiada.");
        });
    },
    setModules(v) {
      this.modules = v.data.results;
    },
    setLessons(v) {
      this.lessons = v.data.results;
    }
  },
  watch: {
    product_id() {
      this.module_id = "";
    },
    module_id() {
      this.lesson_id = "";
    }
  }
};
</script>
